module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Spitfire.9eacd3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Spitfire.jpg
// module id = fARF
// module chunks = 0